import Logo from '@avanta/shared/assets/avanta-logo.svg';
import { Link } from 'react-router';
import { ROUTES } from 'constants/routes';
import { HamburgerMenu } from './HamburgerMenu';

export const MobileNav = (): React.ReactElement => (
  <div className="relative flex h-12 items-center bg-transparent px-4 am-3xl:hidden">
    <Link to={ROUTES.HOME} className="inline-flex items-center">
      <img src={Logo} alt="Avanta Mynd Logo" className="h-8 w-24" />
    </Link>
    <div className="fixed top-0 right-0 z-60 flex h-12 items-center bg-transparent">
      <HamburgerMenu />
    </div>
  </div>
);
